import { BingoMatchStatus, TradePosition, TradeStatus } from '../../enums';
import { Type } from 'class-transformer';
import { IsEnum, IsInt, IsOptional, IsUUID, Max, Min } from 'class-validator';

export class GetTodaysParticipatedMatchesDto {
	@IsEnum(BingoMatchStatus)
	status: BingoMatchStatus;

	@IsUUID()
	lobbyId: string;
}

export class BingoParticipatedMatchDto {
	matchId: string;
	name: string;
	openingTime: Date;
	closingTime: Date;
	correctTradesCount: number | null;
	settledTradesCount: number;
	totalPredictedMarkets: number;
	allMarketsSettled: boolean;
	rank: number | null;
}

export class GetBingoBoardDto {
	@IsUUID()
	matchId: string;

	@IsUUID()
	lobbyId: string;
}

export class GetBingoMatchDetailsDto {
	@IsUUID()
	matchId: string;
}

/** What a bingo match page shows about the match itself. */
export class BingoMatchDetailsDto {
	id: string;
	eventId: string;
	name: string;
	/** Null when the match has neither competitors nor an "A vs B" name. */
	homeName: string | null;
	awayName: string | null;
	openingTime: Date;
	closingTime: Date;
	allMarketsSettled: boolean;
}

export class GetBingoMatchMarketsDto {
	@IsUUID()
	matchId: string;
}

export class BingoMarketLiveOddsDto {
	id: string;
	question: string;
	is_settled: boolean;
	settled_position: TradePosition | null;
	odds: number | null;
}

export class BingoMatchMarketsResponseDto {
	match_started: boolean;
	markets: BingoMarketLiveOddsDto[];
}

export class GetBingoMatchesDto {
	@IsUUID()
	lobbyId: string;
}

export class BingoBoardMarketInfoDto {
	id: string;
	question: string;
	context: string | null;
	current_value: number;
	priority: number | null;
	is_settled: boolean;
}

export class BingoBoardTradeDto {
	id: string;
	position: TradePosition;
	/** Win/lose once the market settles; a hit is a settled market with a winning trade. */
	status: TradeStatus;
}

export class BingoBoardMarketDto {
	position: number;
	market: BingoBoardMarketInfoDto;
	trade: BingoBoardTradeDto | null;
}

export class BingoBoardResponseDto {
	id: string;
	match_id: string;
	lobby_id: string;
	markets: BingoBoardMarketDto[];
}

export class BingoMatchDto {
	id: string;
	name: string;
	opening_time: Date;
	closing_time: Date;
	settled_markets_count: number;
	user_traded_markets_count: number;
}

export class BingoMatchLeaderboardParamsDto {
	@IsUUID()
	matchId: string;

	@IsUUID()
	lobbyId: string;

	@IsInt()
	@Min(0)
	@IsOptional()
	@Type(() => Number)
	skip?: number;

	@IsInt()
	@Min(1)
	@Max(100)
	@IsOptional()
	@Type(() => Number)
	limit?: number;
}

export class BingoLeaderboardRowDto {
	rank: number;
	userId: string;
	fullName: string;
	imgVariants: object | null;
	picks: number | null;
	pts: number;
	bingoLines: number;
	hasFirstBingo?: boolean;
}

export class BingoMatchLeaderboardResponseDto {
	items: BingoLeaderboardRowDto[];
	total: number;
}

export class BingoGlobalLeaderboardParamsDto {
	@IsUUID()
	lobbyId: string;

	@IsInt()
	@Min(0)
	@IsOptional()
	@Type(() => Number)
	skip?: number;

	@IsInt()
	@Min(1)
	@Max(100)
	@IsOptional()
	@Type(() => Number)
	limit?: number;
}

export class BingoGlobalLeaderboardRowDto {
	rank: number;
	userId: string;
	fullName: string;
	imgVariants: object | null;
	pts: number;
	bingoLines: number;
}

export class BingoGlobalRankParamsDto {
	@IsUUID()
	lobbyId: string;
}

/** The signed-in player's place in the lobby's global bingo standings; nulls when unranked. */
export class BingoGlobalRankResponseDto {
	rank: number | null;
	pts: number | null;
}

export class BingoGlobalLeaderboardResponseDto {
	items: BingoGlobalLeaderboardRowDto[];
	total: number;
}
